import {useRouter} from 'next/router';
import {useCallback} from 'react';

import {
  ORDER_FILTER,
  SEARCH_FILTERS,
  SEARCH_TYPE,
} from '@/src/app/constants/search';

import {
  checkExsistingFilter,
  getPathnameFromSearchType,
  serializeFilters,
} from './';

export const useSearchFilters = (userType?: string) => {
  const {query, replace, locale} = useRouter();

  const setQueryFilters = useCallback(
    (filters) => {
      replace(
        {
          pathname: getPathnameFromSearchType(
            query.slug,
            // @ts-ignore
            query.username,
            userType
          ),
          query: serializeFilters(
            checkExsistingFilter({
              ...query,
              [SEARCH_FILTERS.LANGUAGE]: locale,
              [SEARCH_FILTERS.OFFSET]: '0',
              ...filters,
            })
          ),
        },
        undefined,
        {scroll: false}
      );
    },
    [query, locale]
  );

  const onFilterClickHandle = (event) => {
    const filterName = event.target.getAttribute('data-filter-name');
    const filterValue = event.target.getAttribute('data-value');
    const isChecked = event.target.checked;

    setQueryFilters({
      [filterName]: isChecked ? filterValue : '',
      [SEARCH_FILTERS.OFFSET]: '0',
    });
  };

  const onMultipleFilterClickHandle = (event) => {
    const filterName = event.target.getAttribute('data-filter-name');
    const filterValue = event.target.getAttribute('data-value').split(',');
    const isChecked = event.target.checked;

    const combinedFilters = isChecked
      ? [
          // @ts-ignore
          ...(query[filterName] ? JSON.parse(query[filterName]) : []),
          ...filterValue,
        ]
      : // @ts-ignore
        JSON.parse(query[filterName]).filter(
          (itm) => !filterValue.includes(itm)
        );

    const filtersSet = new Set(combinedFilters);

    setQueryFilters({
      [filterName]:
      // @ts-ignore
        combinedFilters.length > 0 ? JSON.stringify([...filtersSet]) : '',
      [SEARCH_FILTERS.OFFSET]: '0',
    });
  };

  const handleClearAllFiltersClick = () => {
    setQueryFilters({
      [SEARCH_FILTERS.OFFSET]: '0',
      [SEARCH_FILTERS.ORDER]: ORDER_FILTER.DESC,
      [SEARCH_FILTERS.LANGUAGE]: locale,
      [SEARCH_FILTERS.SEARCH]: '',
      [SEARCH_FILTERS.ORDER_BY]: '',
      [SEARCH_FILTERS.AVAILABILITY]: '',
      [SEARCH_FILTERS.FILTERS_STATUS]: '',
      [SEARCH_FILTERS.FILTERS_ORIGINAL]: '',
      [SEARCH_FILTERS.FILTERS_CATEGORY_IDS]: '',
      [SEARCH_FILTERS.FILTERS_DIFFICULTY_LEVELS]: '',
      [SEARCH_FILTERS.FILTERS_AVERAGE_SCORE]: '',
      [SEARCH_FILTERS.FILTERS_TYPE]: '',
      [SEARCH_FILTERS.USER_ID]: '',
      [SEARCH_FILTERS.PREFERABLE_POSITION]: '',
      [SEARCH_FILTERS.COUNTRY_IDS]: '',
      [SEARCH_FILTERS.CLINIC_COUNTRIES]: '',
      [SEARCH_FILTERS.CLINIC_STATE]: '',
      [SEARCH_FILTERS.CLINIC_CITY]: '',
      [SEARCH_FILTERS.SALARY_MIN]: '',
      [SEARCH_FILTERS.SALARY_MAX]: '',
      [SEARCH_FILTERS.WORK_TYPES]: '',
      [SEARCH_FILTERS.CLINIC_IDS]: '',
      [SEARCH_FILTERS.ALL_COUNTRIES_IDS]: '',
      [SEARCH_FILTERS.SPECIALTIES]: '',
      [SEARCH_FILTERS.POSITIONS]: '',
    });
  };

  const isTargetUserPage =
    query.slug === SEARCH_TYPE.FOLLOWING ||
    query.slug === SEARCH_TYPE.FOLLOWERS;

  const isSearchPage =
    query.slug === SEARCH_TYPE.POSTS ||
    query.slug === SEARCH_TYPE.COURSES ||
    query.slug === SEARCH_TYPE.USERS ||
    query.slug === SEARCH_TYPE.CLINICS;

  const isWatchlistPage =
    query.slug === SEARCH_TYPE.WATCHLIST_BOOKMARKED ||
    query.slug === SEARCH_TYPE.WATCHLIST_CONTINUE ||
    query.slug === SEARCH_TYPE.WATCHLIST_FINISHED;

  return {
    setQueryFilters,
    onFilterClickHandle,
    onMultipleFilterClickHandle,
    handleClearAllFiltersClick,
    isTargetUserPage,
    isSearchPage,
    isWatchlistPage,
  };
};
